module.exports = __webpack_public_path__ + "img/eurotext_logo_optimized.13b8e70e.svg";